import { GroupStatus } from "authoring/lib/enum/group-status.mjs"
import { GroupType } from "authoring/lib/enum/group-type.mjs"
import { hasLeadingSummaryGroupSchedules } from "./leading-summary-group-validation.mjs"

export function canEditGroupReferences(group = {}) {
    return (
        group?.type === GroupType.LEADING_SUMMARY &&
        group?.status === GroupStatus.EDITING &&
        hasLeadingSummaryGroupSchedules(group)
    )
}
